module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col space-y-5 bg-gray-100 rounded-md py-4 px-5"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [(_vm.provider.name === 'Google Classroom') ? _c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": _vm.provider.icon_url,
      "width": "30px",
      "height": "30px"
    }
  }) : _c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": ("/static/integrations/" + (_vm.provider.name) + ".png"),
      "width": "30px",
      "height": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "px-3 text-base font-poppins font-semibold"
  }, [_vm._v("\n      " + _vm._s(_vm.provider.name) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-grow h-full flex-col space-y-4"
  }, [_c('p', {
    staticClass: "text-sm text-gray-500"
  }, [_vm._v("\n      Which " + _vm._s(_vm.provider.name) + " class do you want to sync to to your Parlay account ?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-2 h-full md:max-h-80 overflow-y-auto"
  }, _vm._l((_vm.courses), function(course, index) {
    return _c('li', {
      staticClass: "flex items-center justify-between bg-white rounded-md w-full hover:border-primary-dark border border-solid cursor-pointer border-white px-4 py-2.5",
      class: {
        'border-primary-dark': _vm.selectedCourse === course
      },
      on: {
        "click": function($event) {
          return _vm.handleSelectCourse(course)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(course.name))]), _vm._v(" "), _c('Checkbox', {
      attrs: {
        "is_checked": _vm.selectedCourse === course
      }
    })], 1)
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-45117af8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/createCoursesFromLms.vue
// module id = 2410
// module chunks = 61